
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.998 24a11.922 11.922 0 01-8.43-3.468.477.477 0 01-.1-.1A11.923 11.923 0 01-.002 12a11.92 11.92 0 013.469-8.43.418.418 0 01.098-.098A11.916 11.916 0 0111.998 0c3.176 0 6.17 1.233 8.433 3.471a.41.41 0 01.092.092A11.92 11.92 0 0123.998 12a11.92 11.92 0 01-3.472 8.434.449.449 0 01-.092.092A11.918 11.918 0 0111.998 24zm-6.87-4.069a10.448 10.448 0 006.87 2.569 10.45 10.45 0 006.87-2.569l-6.87-6.871-6.87 6.871zm14.8-1.06c1.66-1.912 2.57-4.337 2.57-6.871s-.91-4.959-2.57-6.871L13.058 12l6.87 6.871zM4.067 5.13C2.407 7.042 1.498 9.466 1.498 12s.91 4.958 2.569 6.87l6.87-6.87-6.87-6.87zm7.931 5.809l6.87-6.87a10.448 10.448 0 00-6.87-2.569c-2.534 0-4.958.91-6.87 2.569l6.87 6.87z"}})])
          )
        }
      }
    